import React from 'react';
import cls from '@soluto-design/styles/cls';

interface IframeProps {
    url: string;
    title: string;
    className?: string;
}

const Iframe = ({ url, title, className }: IframeProps) => {
    return (
        <div className={cls('relative', className)}>
            <iframe
                src={url}
                title={title}
                width="100%"
                height="100%"
                className="border-none border-[0px] overflow-hidden h-full w-full"
            />
        </div>
    );
};

export default Iframe;
